// extracted by mini-css-extract-plugin
export var description = "styles-module--description--9db11";
export var footerHeader = "styles-module--footer-header--9a321";
export var footerHeaderContainer = "styles-module--footer-header-container--38270";
export var footerLogo = "styles-module--footer-logo--57f70";